module.exports = __webpack_public_path__ + "static/img/1.b8e1228.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/1.png
// module id = SWWd
// module chunks = 0